export const ROUTERS = {
  DASHBOARD: "/",
  LOGIN: "/AdminLoginTop",
  DISCOVERY: "/Discovery",
  GET_ADMIN_LOGIN_DATA: "/GetAdminLoginData",
  TIME_LINE: "/Timeline",
  ALERT: "/Alert",
  MANAGEMENT_SETTING: "/ManagementSetting",
};
